import React from "react";
import TabHub from "@/components/TabHub";
import Eligibility from "@/pages/Eligibility";
import VerifyGenealogy from "@/pages/VerifyGenealogy";

export default function LineageHub() {
  return (
    <TabHub
      testid="lineage-hub"
      eyebrow="Eligibility & Lineage"
      title="Confirm your eligibility, then anchor your genealogy."
      subtitle="Review who the Trust serves, then submit your completed lineage to the Decentralized Blockchain Ancestry Registry."
      tabs={[
        { key: "eligibility", label: "Eligibility & Lineage", component: <Eligibility embedded /> },
        { key: "verify", label: "Verify Genealogy", component: <VerifyGenealogy embedded /> },
      ]}
    />
  );
}
